export enum PayoutType {
    biometrician = 'biometrician',
    grader = 'grader',
    performer = 'performer',
    requester = 'requester',
    specialist = 'specialist',
    supervisor = 'supervisor',
}
